import React from 'react'
import InvoicesList from './invoices/InvoicesList'

/**
 * Main Invoices Page
 * This is the entry point for the invoices section.
 * The actual list implementation is in ./invoices/InvoicesList.tsx
 */
const InvoicesPage: React.FC = () => {
  return <InvoicesList />
}

export default InvoicesPage
